import { render, staticRenderFns } from "./GroupsPage.vue?vue&type=template&id=1820da84&scoped=true&"
import script from "./GroupsPage.vue?vue&type=script&lang=js&"
export * from "./GroupsPage.vue?vue&type=script&lang=js&"
import style0 from "@/views/SyncPage/Tabs/DataPage/Tabs/PeoplePage/style.scss?vue&type=style&index=0&id=1820da84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820da84",
  null
  
)

export default component.exports